import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import AlertForm from '~/components/common/AlertForm/'
import { addSubmit, destroyForm } from '~/modules/alert/actions';

class UploadAlert extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    this.props.destroyForm()
  }

  render() {
    return (
      <AlertForm buttonInfo='Done' submit={this.props.submit} />
    )
  }
}

export default connect(null, mapDispatch({
  submit: (props, formData) => addSubmit(formData),
  destroyForm: () => destroyForm(),
}))(UploadAlert);


// WEBPACK FOOTER //
// ./src/components/Alert/AddAlert/index.js